import {platform} from "@/api/platform";

export default {
    namespaced: true,
    state: {
        permissions: null,
        restrictions: null
    },
    getters: {
        permissions: state => state.permissions,
        restrictions: state => state.restrictions,
        hasPermission: state => (permission) => {

            if (null === state.permissions) {

                return false;
            }

            if ("string" === typeof permission) {

                return -1 !== state.permissions.indexOf(permission);
            }

            return 0 < state.permissions.filter(userPermission => permission.includes(userPermission)).length;
        },
        hasRestriction: state => permission => {

            if (state.restrictions) {

                return undefined !== state.restrictions[permission];
            }

            return false
        },
        getRestriction: state => permission => {

            if (state.restrictions && state.restrictions[permission]) {

                return state.restrictions[permission];
            }

            return {};
        }
    },
    mutations: {
        setPermissions: (state, permissions) => state.permissions = permissions,
        setRestrictions: (state, restrictions) => state.restrictions = restrictions,
    },
    actions: {
        setPermissions: (context, permissions) => context.commit("setPermissions", permissions),
        setRestrictions: (context, restrictions) => context.commit("setRestrictions", restrictions),
        refresh(context) {

            return platform
                .get(`/api/v2/consumers/${this.getters["user/id"]}`, {params: {get: "permissions,validationMap"}})
                .then(response => {

                    context.commit("setRestrictions", response.data.results.validationMap)
                    context.commit("setPermissions", response.data.results.permissions)
                })
        },
        clear: (context) => {

            context.commit("setPermissions", null);
            context.commit("setRestrictions", null);
        }
    }
}